import { DIALOG_CONSTANTS, META_CONSTANTS } from '../actionTypes'

export const metaAction = {
	SAVE_TOAST,
	SAVE_TRANSLATION,
	PRODUCT_DETAIL_SIDEBAR_OPEN,
}

function SAVE_TOAST(toast) {
	return (dispatch) => {
		dispatch(request(toast))
	}

	function request(response) {
		return { type: META_CONSTANTS.SAVE_TOAST, response }
	}
}

function SAVE_TRANSLATION(translate) {
	return (dispatch) => {
		dispatch(request(translate))
	}

	function request(response) {
		return { type: META_CONSTANTS.SAVE_TRANSLATION, response }
	}
}

function PRODUCT_DETAIL_SIDEBAR_OPEN() {
	return (dispatch) => {
		dispatch(request())
	}

	function request() {
		return { type: DIALOG_CONSTANTS.PRODUCT_DETAIL_OPEN }
	}
}
